/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Button, Image, Modal, Row, Col, Empty } from "antd";
import { CloudDownloadOutlined, CloseOutlined, CloseCircleOutlined } from "@ant-design/icons";
import KBN from "../../api/backend/kbn";
import API from "../../api/backend/inventory";
import { KEY, lang } from "../../constants/common.const";
import {
  isEmpty,
  MSG_CATCH,
  saveFile,
  showMessage,
  statusRes,
} from "../../constants/utils";
import classText from "../../models/control/text";
import classDdl from "../../models/control/dropdownlist";
import classCheckbox from "../../models/control/checkbox";
import List from "./list";
import classGrid from "../../models/control/grid";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { checkRoleScreen } from "../../utils/roles";
import classPopup from "../../models/control/popup";
import { LeftOutlined, RightOutlined, EyeOutlined } from "@ant-design/icons";
import { TagVideoList } from "../../component/video/TagVideoList";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}
export default function InventoryData() {
  let query = useQuery();
  const [grid, setGrid] = useState(new classGrid());
  const [popupShowImg, setPopupShowImg] = useState(new classPopup());
  const [loading, setLoading] = useState(true);
  const [item, setItem] = useState(
    new classText(query.get("inventory") || null)
  );
  const [itemType, setItemType] = useState(new classDdl());
  const [category, setCategory] = useState(new classDdl());
  const [warehouses, setWarehouses] = useState(new classDdl());
  const [imgUrl, setImgUrl] = useState("");
  const [chkUnderMinimum, setChkUnderMinimum] = useState(
    new classCheckbox(query.get("status") || false)
  );
  const [imgList, setImgList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const { allowRoute } = useSelector((state) => state.auth);
  const location = useLocation();

  const inputs = [
    {
      name: lang.WAREHOUSES_NAME,
      get: warehouses,
      type: KEY.DDL,
      onChange: (v) => {
        setWarehouses({ ...warehouses, value: v });
      },
    },
    {
      name: lang.CATEGORY,
      get: category,
      type: KEY.DDL,
      onChange: (v) => {
        setCategory({ ...category, value: v });
      },
    },
    {
      name: lang.ITEM,
      get: item,
      type: KEY.TEXT,
      onChange: (e) => {
        setItem({ ...item, value: e.target.value });
      },
    },
    {
      name: lang.ITEM_TYPE,
      get: itemType,
      set: setItemType,
      type: KEY.DDL,
    },
    {
      title: " ",
      name: lang.SHOW_ONLY_ALERTED_ITEMS,
      get: chkUnderMinimum,
      set: setChkUnderMinimum,
      type: KEY.CHECKBOX,
    },
  ];
  const columns = [
    {
      title: lang.ITEM_NAME,
      dataIndex: "inventoryItemName",
      align: "center",
      render: (txt, row) => {
        return <span className="font-size-default">{txt}</span>;
      },
    },
    {
      title: lang.REF_VIDEO_TAG,
      dataIndex: "tag",
      align: "center",
      width:200,
      render: (txt, row) => {
        return <div className="font-size-default"><TagVideoList tags={row.tagLists || []} /></div>;
      },
    },
    {
      title: "添付写真",
      align: "center",
      dataIndex: "",
      render: (txt, row) => {
        if (row.warehouseItems) {
          return (
            row.inventoryItemAttachments.length > 0 ?
            <Button type="link" onClick={() => showImgItem(row)}>
              <span className="font-size-default">参考</span>
            </Button> : <span className="font-size-default">ー</span>
          );
        }
        return null;
      },
    },
    {
      title: lang.INVENTORY_UNIT,
      dataIndex: "inventoryUnit",
      align: "center",
    },
    {
      title: lang.WAREHOUSES_NAME,
      dataIndex: "inventoryWarehouseName",
      align: "center",
    },

    {
      title: lang.STOCK_QUANTITY,
      dataIndex: "sumStockQuantity",
      align: "center",
      render: (txt, row) => {
        let code = row.stockQuantity || row.sumStockQuantity;
        if (row.stockQuantity == 0) code = 0;
        return <div style={{ fontWeight: "bold" }}>{code}</div>;
      },
    },
    {
      title: lang.MINIMUM_STOCK_QUANTITY,
      dataIndex: "sumMinimumRequiredQuantity",
      align: "center",
      render: (txt, row) => {
        let code = row.minimumRequiredQuantity || "";
        if (row.minimumRequiredQuantity == 0) code = 0;
        return <div>{code}</div>;
      },
    },
    {
      title: lang.CATEGORY_NAME,
      dataIndex: "categoryName",
      align: "center",
    },
    {
      title: lang.ITEM_TYPE,
      dataIndex: "inventoryType",
      align: "center",
    },
    {
      title: lang.ITEM_CODE,
      dataIndex: "inventoryWarehouseItemCode",
      align: "center",
      render: (txt, row) => {
        let code = row.inventoryItemCode || row.inventoryWarehouseItemCode;
        return <div>{code}</div>;
      },
    },
  ];

  const prevImages = () => {
    // Nếu đang ở ảnh đầu tiên, sẽ không lùi được
    if (currentIndex > 1) {
      setCurrentIndex(currentIndex - 2); // Lùi lại 2 ảnh
    } else if (currentIndex === 1) {
      setCurrentIndex(0); // Khi chỉ còn 1 ảnh trước đó
    }
  };

  // Hàm xử lý "Next"
  const nextImages = () => {
    // Nếu còn đủ 2 ảnh phía sau
    if (currentIndex + 2 < imgList.length) {
      setCurrentIndex(currentIndex + 2); // Tiến lên 2 ảnh
    } else if (currentIndex + 1 < imgList.length) {
      setCurrentIndex(currentIndex + 1); // Nếu chỉ còn 1 ảnh, tiến lên 1 ảnh cuối
    }
  };

  // Điều chỉnh currentImages để hiển thị 2 ảnh mỗi lần
  const currentImages =
    imgList.length === 1
      ? [imgList[0]] // Nếu chỉ có 1 ảnh
      : [
          imgList[currentIndex],
          currentIndex + 1 < imgList.length ? imgList[currentIndex + 1] : null, // Nếu còn ảnh tiếp theo thì lấy, nếu không thì null
        ].filter((img) => img !== null); // Lọc bỏ giá trị null (nếu chỉ còn 1 ảnh)

  const handleOk = () => {
    setPopupShowImg({ ...popupShowImg, show: false });
  };

  const handleCancel = () => {
    setPopupShowImg({ ...popupShowImg, show: false });
    setCurrentIndex(0);
  };

  const showImgItem = (row) => {
    setImgList([]);
    if (row.inventoryItemAttachments.length > 0) {
      setImgList(
        row.inventoryItemAttachments.map((attachment) => attachment.imageUrl)
      );
    }
    setPopupShowImg({ ...popupShowImg, show: true })
  };

  const getFacility = () => {
    return KBN.getWarehouses()
      .then((res) => {
        if (statusRes(res)) {
          setWarehouses({
            ...warehouses,
            options: res.data.data.map((v) => {
              v["key"] = v.inventoryWarehouseCode;
              v["value"] = v.inventoryWarehouseName;
              return v;
            }),
          });
        } else {
          throw new Error();
        }
      })
      .catch((err) => {
        showMessage(KEY.ERROR, MSG_CATCH());
      });
  };
  const getInventoryType = () => {
    return KBN.getInventoryType().then((res) => {
      if (statusRes(res)) {
        setItemType((preV) => ({
          ...preV,
          options: res.data.data,
        }));
      } else {
        throw new Error();
      }
    });
  };
  const getParams = {
    inventoryItem: isEmpty(item.value) ? null : item.value.trim(),
    category: isEmpty(category.value)
      ? null
      : category.options.find((x) => x.key === category.value)
      ? category.options.find((x) => x.key === category.value).value
      : null,
    inventoryWarehouseCode: warehouses.value,
    inventoryType: itemType.value,
    underMinimumStockOnly: chkUnderMinimum.checked,
  };
  const onSearch = (offset = 0) => {
    setGrid((preV) => ({ ...preV, loading: true }));

    // Call
    return API.searchInventoryData({
      ...getParams,
      offset: offset,
      limit: 20,
    })
      .then((res) => {
        if (statusRes(res)) {
          const { data, count } = res.data;
          if (offset === 0) {
            // Init, Click
            setGrid((preV) => ({
              ...preV,
              data: data,
              count: count,
              hasMore: true,
              loading: false,
            }));
          } else {
            // Load more
            setGrid((preV) => ({
              ...preV,
              data: [...preV.data, ...data],
              count: count,
              loading: false,
            }));
          }
        } else {
          showMessage(KEY.ERROR, MSG_CATCH());
        }
      })
      .catch((err) => {
        showMessage(KEY.ERROR, MSG_CATCH());
      })
      .then(() => {
        setGrid((preV) => ({ ...preV, loading: false }));
      });
  };
  const onLoadMore = () => {
    let { data, count } = grid;

    if (data.length >= count) {
      // max
      setGrid((preV) => ({ ...preV, loading: false, hasMore: false }));
    } else {
      // load more
      onSearch(data.length);
    }
  };
  const clearInput = () => {
    setItem({ ...item, value: null });
    setItemType({ ...itemType, value: null });
    setCategory({ ...category, value: null });
    setWarehouses({ ...warehouses, value: null });
    setChkUnderMinimum(new classCheckbox());
  };
  const onExport = () => {
    setLoading(true);

    // Call
    return API.downloadItemsForTransactions(getParams)
      .then((res) => {
        if (statusRes(res)) {
          saveFile(res);
        } else {
          showMessage(KEY.ERROR, MSG_CATCH());
        }
      })
      .catch((err) => {
        showMessage(KEY.ERROR, MSG_CATCH());
      })
      .then(() => {
        setLoading(false);
      });
  };
  const getCategory = () => {
    return KBN.getCategories()
      .then((res) => {
        if (statusRes(res)) {
          setCategory({
            ...category,
            options: res.data.data.map((v) => {
              v["key"] = v.categoryCode;
              v["value"] = v.categoryName;
              return v;
            }),
          });
        } else {
          throw new Error();
        }
      })
      .catch((err) => {
        showMessage(KEY.ERROR, MSG_CATCH());
      });
  };

  // Init
  useEffect(() => {
    if (checkRoleScreen(location.pathname, allowRoute)) {
      setWarehouses({ ...warehouses, value: null });
      getParams.inventoryWarehouseCode = null;
      setCategory({ ...category, value: null });
      setLoading(true);
      Promise.all([
        onSearch(),
        getFacility(),
        getInventoryType(),
        getCategory(),
      ])
        .catch((err) => {
          showMessage(KEY.ERROR, MSG_CATCH());
        })
        .then(() => {
          setLoading(false);
        });
    }
  }, [allowRoute]);

  return (
    <>
      <List
        expandable={{
          childrenColumnName: "warehouseItems",
        }}
        className="table-header-auto gridSearch"
        inputs={inputs}
        columns={columns}
        rowKey={(row) =>
          row.inventoryItemCode || row.inventoryWarehouseItemCode
        }
        // grid={grid}
        grid={grid}
        keyList="inventoryData"
        actionSearch={() => {
          onSearch();
        }}
        loadMore={onLoadMore}
        clearInput={clearInput}
        btnAdd={
          <>
            <Button
              disabled={grid.data.length === 0}
              className="buttonPC button--back mb10"
              onClick={onExport}
              icon={
                <CloudDownloadOutlined
                  style={{
                    color: "#f50",
                  }}
                />
              }
            >
              {lang.EXPORT}
            </Button>
          </>
        }
        linkAdd="/ItemUpdate"
        loading={loading}
        rowClassName={(row, index) => {
          const err =
            Number(row.minimumRequiredQuantity) >
              Number(row.currentStockQuantity || row.stockQuantity) ||
            (row.warehouseItems &&
              row.warehouseItems.some(
                (item) => item.stockQuantity < item.minimumRequiredQuantity
              ));

          return err ? "row-highlight" : "";
        }}
      />
      <Modal
        centered
        visible={popupShowImg.show}
        onOk={handleOk}
        width={1000}
        onCancel={handleCancel}
        footer={[
          <Button
            className="buttonPC button--outline --todo-- wAuto"
            key="back"
            onClick={handleCancel}
          >
            <CloseCircleOutlined /> {lang.CANCEL}
          </Button>,
        ]}
      >
        {imgList.length > 0 && <Row justify="center" align="middle">
          {imgList.length !== 1 && (
            <Button
              type="text"
              icon={<LeftOutlined />}
              onClick={prevImages}
              disabled={currentIndex === 0}
            />
          )}

          <Row gutter={16} justify="center" className="carousel-container">
            {currentImages.map((url, index) => (
              <Col key={index} className="carousel-image-wrapper">
                <div className="image-container">
                  <Image
                    src={url}
                    alt={`image-${index}`}
                    className="carousel-image"
                    preview={{
                      mask: <EyeOutlined style={{ fontSize: 24 }} />,
                      onVisibleChange: (visible) => {
                        if (visible) {
                          setPopupShowImg({
                            ...popupShowImg,
                            show: false,
                          });
                        } else {
                          setPopupShowImg({
                            ...popupShowImg,
                            show: true,
                          });
                        }
                      },
                    }}
                  />
                </div>
              </Col>
            ))}
          </Row>
          {imgList.length !== 1 && (
            <Button
              type="text"
              icon={<RightOutlined />}
              onClick={nextImages}
              disabled={currentIndex + 2 >= imgList.length}
            />
          )}
        </Row>}
        {imgList.length === 0 && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
      </Modal>
    </>
  );
}
